<template>
  <div>
    <div class="search-bar">
      <Input v-model="searchQuery" placeholder="搜索提示词名称或内容" clearable style="width: 300px" />
      <Button type="primary" @click="handleSearch" style="margin-left: 10px">搜索</Button>
      <Button type="success" @click="handleAdd" style="margin-left: 10px">新建提示词</Button>
    </div>

    <div class="table-wrapper">
        <BaseTable
          :columns="columns"
          :data="filteredData"
          :loading="loading"
          border
        ></BaseTable>
    </div>

    <Modal
      v-model="modalVisible"
      :title="modalTitle"
      width="900"
      @on-ok="handleSubmit"
      :loading="confirmLoading"
    >
      <Form ref="formRef" :model="formData" :rules="rules" :label-width="120">
        <div class="form-section">
          <h3>基本信息</h3>
          <div class="form-row">
            <FormItem label="名称" name="name" class="form-item">
              <Input v-model="formData.name" placeholder="请输入提示词名称" />
            </FormItem>
            <FormItem label="模块" name="mod" class="form-item">
              <Input v-model="formData.mod" placeholder="请输入模块名称" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="颜色" name="color" class="form-item">
              <BaseColorSelect v-model="formData.color" />
            </FormItem>
            <FormItem label="是否共享" name="shared" class="form-item">
              <i-switch v-model="formData.shared" :true-value="true" :false-value="false" />
            </FormItem>
          </div>
          <div class="form-row">
            <FormItem label="归属部门" name="dep_id" class="form-item">
              <BaseDepSelectPro v-model="formData.dep_id" />
            </FormItem>
            <div class="form-item"></div>
          </div>
          <FormItem label="提示词内容" name="content">
            <Input type="textarea" v-model="formData.content" :rows="6" placeholder="请输入提示词内容" />
          </FormItem>
          <FormItem label="输入示例" name="demo">
            <Input type="textarea" v-model="formData.demo" :rows="3" placeholder="请输入输入示例" />
          </FormItem>
        </div>

        <div class="form-section">
          <h3>关联模块</h3>
          <div class="form-row">
            <FormItem label="参数编辑模块" name="param_editor" class="form-item">
              <Input v-model="formData.param_editor" placeholder="参数编辑模块ID" />
            </FormItem>
            <FormItem label="数据编辑模块" name="data_editor" class="form-item">
              <Input v-model="formData.data_editor" placeholder="数据编辑模块ID" />
            </FormItem>
          </div>
          <FormItem label="数据展示模块" name="report_view">
            <Input v-model="formData.report_view" placeholder="数据展示模块ID" />
          </FormItem>
        </div>

        <div class="form-section">
          <h3>其他配置</h3>
          <FormItem label="导出模板" name="docx_tmpl_url">
            <BaseFileUpload 
              v-model="formData.docx_tmpl_url" 
              label="上传DOCX模板文件" 
              accept="application/vnd.openxmlformats-officedocument.wordprocessingml.document" 
            />
          </FormItem>
          <FormItem label="选项配置(JSON)" name="option">
            <Input 
              type="textarea" 
              v-model="optionJson" 
              :rows="6" 
              placeholder='请输入JSON配置，例如: {"key": "value"}'
              @on-blur="handleOptionBlur"
            />
            <div style="color: #999; font-size: 12px; margin-top: 5px;">
              提示：输入有效的JSON格式，留空则保存为空对象
            </div>
          </FormItem>
        </div>
      </Form>
    </Modal>


    <!-- AI应用对话框 -->
    <Modal
      v-model="appModalVisible"
      :title="`提示词应用 (${appRecord.id})`"
      width="1200"
      :footer-hide="true"
    >
      <div class="ai-app-container">
        <!-- 上方信息区域 -->
        <div class="ai-app-header">
          <div class="ai-header-main">
            <div class="ai-title-row">
              <h2 class="ai-title">{{ appRecord.name || '提示词应用' }}</h2>
              <div class="ai-color-badge" v-if="appRecord.color" :style="{background: appRecord.color}"></div>
            </div>
            <div class="ai-desc" v-if="appRecord.desc">{{ appRecord.desc }}</div>
            <div class="ai-meta-info">
              <div class="ai-meta-item" v-if="appRecord.mod">
                <span class="ai-meta-label">模块：</span>
                <Tag color="blue" size="small">{{ appRecord.mod }}</Tag>
              </div>
              <div class="ai-meta-item" v-if="appRecord.dep_id">
                <span class="ai-meta-label">归属部门：</span>
                <span>{{ getDepName(appRecord.dep_id) }}</span>
              </div>
              <div class="ai-meta-item">
                <span class="ai-meta-label">返回类型：</span>
                <Tag :color="getValueTypeColor(appRecord.value_type || 'markdown')" size="small">
                  {{ getValueTypeText(appRecord.value_type || 'markdown') }}
                </Tag>
              </div>
            </div>
            <div>访问接口为: {{ origin+`/public/ai-chat/${appRecord.id}` }}</div>
          </div>
        </div>

        <!-- 中间输入区域：提示词和用户输入并排 -->
        <div class="ai-app-input-section">
          <div class="ai-input-left">
            <div class="ai-label">提示词内容：</div>
            <Input 
              v-model="appPrompt" 
              type="textarea" 
              :rows="12" 
              placeholder="提示词内容"
              :readonly="true"
              class="ai-prompt-input"
            />
          </div>
          <div class="ai-input-right">
            <div class="ai-label">用户输入：</div>
            <Input 
              v-model="appUserInput" 
              type="textarea" 
              :rows="12" 
              placeholder="请输入您的问题或内容"
              class="ai-user-input"
            />
            <div class="ai-actions">
              <Button 
                type="primary" 
                size="large"
                @click="handleSendMessage"
                :loading="appLoading"
                :disabled="!appUserInput || !appUserInput.trim()"
                icon="md-send"
              >
                发送
              </Button>
              <Button 
                @click="handleClearOutput"
                size="large"
                style="margin-left: 10px"
              >
                清空输出
              </Button>
            </div>
          </div>
        </div>

        <!-- 下方输出区域 -->
        <div class="ai-app-section">
          <div class="ai-label">AI回复：</div>
          <div class="ai-output-container" :class="`output-${appRecord.value_type || 'markdown'}`">
            <BaseMarkdownEditor
              v-if="(appRecord.value_type || 'markdown') === 'markdown'"
              v-model="appOutput"
              :preview="true"
              style="min-height: 300px; max-height: 500px; overflow-y: auto;"
            />
            <div v-else-if="(appRecord.value_type || 'markdown') === 'json'" class="ai-json-output">
              <pre>{{ formatJsonOutput(appOutput) }}</pre>
            </div>
            <div v-else-if="(appRecord.value_type || 'markdown') === 'html'" class="ai-html-output" v-html="appOutput"></div>
            <div v-else class="ai-text-output">{{ appOutput }}</div>
          </div>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [],
      searchQuery: '',
      loading: false,
      confirmLoading: false,
      modalVisible: false,
      modalTitle: '添加提示词',
      currentId: null,
      formData: this.getInitialFormData(),
      optionJson: '',
      // AI应用对话框相关
      appModalVisible: false,
      appModalTitle: '提示词应用',
      appPrompt: '',
      appUserInput: '',
      appOutput: '',
      appLoading: false,
      currentAppId: null,
      appRecord: {},

      columns: [
        {type: 'index', width: 80, title: '序号'},
        {
          title: '名称',
          key: 'name',
          minWidth: 150,
          align: 'left',
          render: (h, params) => {
            return h('a', {
              style: {
                color: '#2d8cf0',
                cursor: 'pointer',
                margin:'0 10px',
                textDecoration: 'none',
              },
              on: {
                click: () => {
                  this.handleOpenApp(params.row);
                },
              },
            }, params.row.name);
          },
        },
        {
          title: '模块',
          key: 'mod',
          width: 120,
          render: (h, params) => {
            if (!params.row.mod) return h('span', {style: {color: '#ccc'}}, '-');
            return h('Tag', {
              props: {
                color: 'blue',
              },
            }, params.row.mod);
          },
        },
        {
          title: '颜色',
          key: 'color',
          width: 80,
          render: (h, params) => {
            if (!params.row.color) return h('span', '-');
            return h('div', {
              style: {
                width: '30px',
                height: '30px',
                background: params.row.color,
                borderRadius: '4px',
                border: '1px solid #ddd',
                margin: '0 auto',
              },
            });
          },
        },
        {
          title: '共享',
          key: 'shared',
          width: 80,
          align: 'center',
          render: (h, params) => {
            return h('Tag', {
              props: {
                color: params.row.shared ? 'green' : 'default',
              },
            }, params.row.shared ? '是' : '否');
          },
        },
        {
          title: '归属部门',
          key: 'dep_id',
          width: 150,
          render: (h, params) => {
            if (!params.row.dep_id) return h('span', {style: {color: '#ccc'}}, '未分配');
            const dep = this.getDepName(params.row.dep_id);
            return h('span', dep || params.row.dep_id);
          },
        },
        {
          title: '调用次数',
          key: 'invoked_count',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('span', {
                style:{
                    color:params.row.invoked_count > 0 ? 'var(--success)' : 'var(--subtext2)',
                }
            }, params.row.invoked_count || 0);
          },
        },
        {
          title: '最后调用',
          key: 'last_invoked_at',
          width: 180,
          render: (h, params) => {
            if (!params.row.last_invoked_at) return h('span', '-');
            return h('span', this.formatTime(params.row.last_invoked_at));
          },
        },
        {type: 'time', title: '创建时间', key: 'created_at', width: 180},
        {
          title: '操作',
          key: 'action',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                },
                style: {
                  marginRight: '5px',
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleEdit(params.row);
                  },
                },
              }, '编辑'),
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small',
                },
                style: {
                  color: '#fff',
                },
                on: {
                  click: () => {
                    this.handleDelete(params.row);
                  },
                },
              }, '删除'),
            ]);
          },
        },
      ],
      rules: {
        name: [{required: true, message: '请输入名称', trigger: 'blur'}],
        content: [{required: true, message: '请输入提示词内容', trigger: 'blur'}],
      },
    };
  },
  computed: {
    filteredData() {
      let result = [...this.items];

      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter((item) =>
          (item.name && item.name.toLowerCase().includes(query)) ||
          (item.content && item.content.toLowerCase().includes(query)) ||
          (item.demo && item.demo.toLowerCase().includes(query)),
        );
      }

      return result;
    },
    origin(){
        return location.origin;
    }
  },
  mounted() {
    this.$api.afterLogin(() => {
      this.fetchData();
    });
  },
  methods: {
    getInitialFormData() {
      return {
        name: '',
        content: '',
        mod: '',
        color: '',
        shared: false,
        dep_id: '',
        docx_tmpl_url: '',
        option: {},
        param_editor: '',
        data_editor: '',
        report_view: '',
        demo: '',
      };
    },
    handleSearch() {
      // 搜索逻辑在computed中处理
    },
    async fetchData() {
      this.loading = true;
      try {
        const response = await this.$api.get('/ai/parse?q=all');
        this.items = response.data.data || [];
      } catch (error) {
        this.$Message.error('获取提示词列表失败');
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    handleAdd() {
      this.modalTitle = '添加提示词';
      this.formData = this.getInitialFormData();
      this.optionJson = '';
      this.currentId = null;
      this.modalVisible = true;
    },
    handleEdit(record) {
      this.modalTitle = '编辑提示词';
      this.formData = {...record};
      // 处理option字段
      if (this.formData.option) {
        if (typeof this.formData.option === 'string') {
          try {
            this.formData.option = JSON.parse(this.formData.option);
          } catch (e) {
            this.formData.option = {};
          }
        }
        // 确保option是对象
        if (typeof this.formData.option !== 'object' || this.formData.option === null) {
          this.formData.option = {};
        }
        this.optionJson = JSON.stringify(this.formData.option, null, 2);
      } else {
        this.formData.option = {};
        this.optionJson = '';
      }
      this.currentId = record.id;
      this.modalVisible = true;
    },
    async handleDelete(record) {
      this.$Modal.confirm({
        title: '确认删除',
        content: `确定要删除提示词"${record.name}"吗？`,
        onOk: async () => {
          try {
            await this.$api.delete(`/ai/parse/${record.id}`);
            this.$Message.success('删除成功');
            this.fetchData();
          } catch (error) {
            this.$Message.error('删除失败');
            console.error(error);
          }
        },
      });
    },
    handleOptionBlur() {
      // 验证JSON格式
      if (this.optionJson && this.optionJson.trim()) {
        try {
          const parsed = JSON.parse(this.optionJson);
          this.formData.option = parsed;
        } catch (e) {
          this.$Message.warning('JSON格式不正确，请检查');
        }
      } else {
        this.formData.option = {};
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.formRef.validate();
        
        // 处理option字段
        if (this.optionJson && this.optionJson.trim()) {
          try {
            this.formData.option = JSON.parse(this.optionJson);
          } catch (e) {
            this.$Message.error('JSON格式不正确，请检查');
            return;
          }
        } else {
          this.formData.option = {};
        }

        this.confirmLoading = true;

        const submitData = {...this.formData};
        // 确保option是JSON字符串
        if (typeof submitData.option === 'object' && submitData.option !== null) {
          submitData.option = JSON.stringify(submitData.option);
        } else if (!submitData.option) {
          submitData.option = JSON.stringify({});
        }

        if (this.currentId) {
          // 更新
          await this.$api.patch(`/ai/parse/${this.currentId}`, submitData);
          this.$Message.success('更新成功');
        } else {
          // 新增
          await this.$api.post('/ai/parse', submitData);
          this.$Message.success('添加成功');
        }

        this.modalVisible = false;
        this.fetchData();
      } catch (error) {
        if (error.message) {
          // 表单验证错误
          return;
        }
        this.$Message.error(error.message || '提交失败');
        console.error(error);
      } finally {
        this.confirmLoading = false;
      }
    },
    formatTime(time) {
      if (!time) return '-';
      return this.$moment(time).format('YYYY-MM-DD HH:mm:ss');
    },
    getDepName(depId) {
      if (!depId) return '';
      const deps = this.$store.getters['session/deps'];
      if (!deps) return '';
      const dep = deps.find(d => d.id === depId);
      return dep ? dep.name : '';
    },
    handleOpenApp(record) {
      this.appRecord = {...record};
      this.appPrompt = record.content || '';
      this.appUserInput = record.demo || ''; // 默认填入示例
      this.appOutput = '';
      this.currentAppId = record.id;
      this.appModalVisible = true;
    },
    getValueTypeText(valueType) {
      const typeMap = {
        'json': 'JSON',
        'markdown': 'Markdown',
        'html': 'HTML',
      };
      return typeMap[valueType] || 'Markdown';
    },
    getValueTypeColor(valueType) {
      const colorMap = {
        'json': 'orange',
        'markdown': 'blue',
        'html': 'green',
      };
      return colorMap[valueType] || 'blue';
    },
    formatJsonOutput(output) {
      if (!output) return '';
      try {
        const parsed = JSON.parse(output);
        return JSON.stringify(parsed, null, 2);
      } catch (e) {
        return output;
      }
    },
    handleSendMessage() {
      if (!this.appUserInput || !this.appUserInput.trim()) {
        this.$Message.warning('请输入内容');
        return;
      }
      if (!this.currentAppId) {
        this.$Message.error('应用ID不存在');
        return;
      }

      this.appLoading = true;
      this.appOutput = '';

      // 使用流式请求
      const content = this.appUserInput;
      fetch(`${this.$api.defaults.baseURL}/ai/parse/${this.currentAppId}`, {
        method: 'POST',
        body: JSON.stringify({
          content: content,
          stream: true,
        }),
        headers: {
          ...this.$api.defaults.headers,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const that = this;
        const reader = response.body.getReader();
        const decoder = new TextDecoder();
        let result = '';

        const ReadStream = () => {
          reader.read().then(({done, value}) => {
            if (done) {
              that.appLoading = false;
              // 更新调用次数和最后调用时间
              that.fetchData();
              return;
            }
            const decodedText = decoder.decode(value, {stream: true});
            result += decodedText;
            that.appOutput = result;
            // 自动滚动到底部
            that.$nextTick(() => {
              const outputContainer = document.querySelector('.ai-output-container');
              if (outputContainer) {
                outputContainer.scrollTop = outputContainer.scrollHeight;
              }
            });
            ReadStream();
          }).catch((error) => {
            console.error('Stream read error:', error);
            that.appLoading = false;
            that.$Message.error('获取回复失败');
          });
        };

        ReadStream();
      }).catch((error) => {
        console.error('Request error:', error);
        this.appLoading = false;
        this.$Message.error('请求失败');
      });
    },
    handleClearOutput() {
      this.appOutput = '';
    },
  },
};
</script>

<style scoped>
.search-bar {
  border-bottom: 1px solid var(--border);
  padding: 15px;
  background: #fff;
  display: flex;
  align-items: center;
}

.table-wrapper {
  position: relative;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  overflow:hidden;
}

.table-wrap {
  position: relative;
  height: calc(100vh - 120px);
  overflow: auto;
  width: 100%;
}

.form-section {
  margin-bottom: 20px;
}

.form-section h3 {
  font-size: 16px;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f0f0f0;
}

.form-row {
  display: flex;
  margin: 0 -8px;
}

.form-item {
  padding: 0 8px;
  flex: 1;
}

.ai-app-container {
  padding: 10px 0;
}

.ai-app-section {
  margin-bottom: 20px;
}

.ai-label {
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
}

.ai-actions {
  margin-top: 10px;
  display: flex;
  align-items: center;
}

.ai-app-container {
  padding: 0;
}

.ai-app-header {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.ai-header-main {
  position: relative;
}

.ai-title-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.ai-title {
  color: #fff;
  font-size: 24px;
  font-weight: 600;
  margin: 0;
  margin-right: 12px;
}

.ai-color-badge {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.3);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ai-desc {
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 15px;
}

.ai-meta-info {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  align-items: center;
}

.ai-meta-item {
  display: flex;
  align-items: center;
  color: rgba(255, 255, 255, 0.95);
  font-size: 13px;
}

.ai-meta-label {
  margin-right: 6px;
  opacity: 0.8;
}

.ai-app-input-section {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.ai-input-left,
.ai-input-right {
  flex: 1;
}

.ai-label {
  font-weight: 500;
  margin-bottom: 8px;
  color: #333;
  font-size: 14px;
}

.ai-prompt-input,
.ai-user-input {
  width: 100%;
}

.ai-actions {
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.ai-output-container {
  border: 1px solid #e8eaec;
  border-radius: 4px;
  padding: 15px;
  background: #fafafa;
  min-height: 300px;
  max-height: 500px;
  overflow-y: auto;
}

.ai-json-output {
  background: #282c34;
  color: #abb2bf;
  padding: 15px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-size: 13px;
  line-height: 1.6;
}

.ai-json-output pre {
  margin: 0;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.ai-html-output {
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  min-height: 300px;
}

.ai-text-output {
  padding: 15px;
  background: #fff;
  border-radius: 4px;
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height: 1.6;
  min-height: 300px;
}

.output-json {
  background: #282c34;
}

.output-html {
  background: #fff;
}

.output-markdown {
  background: #fafafa;
}
</style>

